import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { usePortalDropdown } from "../../hooks/usePortalDropdown";
import PortalDropdown from "../ui/PortalDropdown";
import MoreIcon from "../Icons/MoreIcon";

/**
 * "More" menu shown next to the status board title. Opens a dropdown with an
 * Archives entry.
 */
const ShipmentBoardMoreMenu: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { open, coords, triggerRef, dropdownRef, toggle, close } =
    usePortalDropdown();

  const handleToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    toggle();
  };

  const goToArchives = (e: React.MouseEvent) => {
    e.stopPropagation();
    close();
    navigate("/features/shipment-tracker/archives");
  };

  return (
    <>
      <button
        ref={triggerRef}
        className="portal-dropdown__trigger portal-dropdown__trigger--lg"
        onClick={handleToggle}
        aria-label="More"
      >
        <MoreIcon horizontal />
      </button>

      <PortalDropdown open={open} coords={coords} dropdownRef={dropdownRef}>
        <button className="portal-dropdown__item" onClick={goToArchives}>
          {t("archives_title")}
        </button>
      </PortalDropdown>
    </>
  );
};

export default ShipmentBoardMoreMenu;
